"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../../utils/api");
var registerDevice_1 = __importDefault(require("./queries/registerDevice"));
var updateDeviceName_1 = __importDefault(require("./queries/updateDeviceName"));
var getDevices_1 = __importDefault(require("./queries/getDevices"));
var deactivateDevice_1 = __importDefault(require("./queries/deactivateDevice"));
var toolkit_1 = require("@reduxjs/toolkit");
var constants_1 = require("./constants");
var config_1 = __importStar(require("../../config"));
var getDeviceSessions_1 = __importDefault(require("./queries/getDeviceSessions"));
var signOutDevice_1 = __importDefault(require("./queries/signOutDevice"));
var signOutAllDevices_1 = __importDefault(require("./queries/signOutAllDevices"));
exports.registerDevice = function (device) {
    return api_1.createApiAction(constants_1.REGISTER_DEVICE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: registerDevice_1.default,
            variables: { registerDevice: device },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.fetchDevices = function () {
    return api_1.createApiAction(constants_1.FETCH_DEVICES, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getDevices_1.default,
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.deactivateDevice = function (deviceId) {
    return api_1.createApiAction(constants_1.DEACTIVATE_DEVICE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: deactivateDevice_1.default,
            variables: { deviceId: deviceId },
        },
        authenticated: true,
        graphQL: true,
        onSuccess: function (dispatch) {
            dispatch(exports.fetchDevices());
        },
    });
};
exports.updateDeviceName = function (deviceId, deviceName) {
    return api_1.createApiAction(constants_1.UPDATE_DEVICE_NAME, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: updateDeviceName_1.default,
            variables: { deviceId: deviceId, deviceName: deviceName },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.setPlaybackDevice = function (playbackDevice) {
    return toolkit_1.createAction(constants_1.SET_PLAYBACK_DEVICE)(playbackDevice);
};
exports.setSerialNumber = function (serialNumber) {
    return toolkit_1.createAction(constants_1.SET_SERIAL_NUMBER)(serialNumber);
};
exports.fetchDeviceSessions = function (appId) {
    return api_1.createApiAction(constants_1.FETCH_DEVICE_SESSIONS, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: getDeviceSessions_1.default,
            variables: { appId: appId },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.signOutDevice = function (appId, deviceTypes) {
    return api_1.createApiAction(constants_1.SIGN_OUT_DEVICE, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: signOutDevice_1.default,
            variables: { appId: appId, deviceTypes: deviceTypes },
        },
        authenticated: true,
        graphQL: true,
        meta: { deviceTypes: deviceTypes },
    });
};
exports.signOutAllDevices = function (appId) {
    return api_1.createApiAction(constants_1.SIGN_OUT_ALL_DEVICES, {
        baseURL: config_1.default.EXP_API_URL + config_1.GRAPH_QL_PATH,
        params: {
            query: signOutAllDevices_1.default,
            variables: { appId: appId },
        },
        authenticated: true,
        graphQL: true,
    });
};
exports.resetSignOutDevice = function () { return toolkit_1.createAction(constants_1.RESET_SIGN_OUT_DEVICE)(); };
//# sourceMappingURL=actions.js.map